import React, { memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { FetchNewRxList } from '../../services/reducers/pharmacy/accountibility/accountibilityNewRx'
import { useAccountibilitySelector } from '../../services/selectors/accountabilitySelectors'
import { RxNumber } from '../../screens/pharmacy/Accountability/helper'

// Color mapping based on row index (moved outside to prevent recreation)
const TEXT_COLORS = ['text-green-600', 'text-orange-500', 'text-black']

const getTextColor = (index) => TEXT_COLORS[Math.min(index, 2)]

// New RX Card Component
const NewRxCard = memo(() => {
	const dispatch = useDispatch()
	const { fetchNewRxListResponse } = useAccountibilitySelector()

	const loading = fetchNewRxListResponse?.loading
	const error = fetchNewRxListResponse?.error
	const patients = fetchNewRxListResponse?.data?.data || []

	useEffect(() => {
		
		dispatch(FetchNewRxList({
			fetchType: 'fetchNewRxList',
		}))
	}, [dispatch])

	if (loading) {
		return (
			<div className="mb-3 rounded-md  bg-white border border-gray-300 animate-pulse">
				<div className="px-2 py-1 border-b border-gray-200">
					<div className="flex items-start">
						
						<div className="w-[40%] h-3 bg-gray-200 rounded"></div>
						<div className="w-[60%] h-3 bg-gray-200 rounded ml-2"></div>
					</div>
				</div>
				<div className="px-2 py-1 border-b border-gray-200">
					<div className="flex items-start">
						<div className="w-[40%] h-3 bg-gray-200 rounded"></div>
						<div className="w-[60%] h-3 bg-gray-200 rounded ml-2"></div>
					</div>
				</div>
				<div className="px-2 py-1">
					<div className="flex items-start">
						<div className="w-[40%] h-3 bg-gray-200 rounded"></div>
						<div className="w-[60%] h-3 bg-gray-200 rounded ml-2"></div>
					</div>
				</div>
			</div>
		)
	}

	if (error) {
		return (
			<div className="mb-3 rounded-md overflow-hidden bg-white border border-red-300 p-2">
				<p className="text-xs text-red-500 text-center">{error}</p>
			</div>
		)
	}

if (!patients || patients.length === 0) return null


	return (
		<div className="mb-3 rounded-md overflow-hidden bg-white border border-gray-300">
			<div className="px-2 py-1 bg-gray-50 border-b border-gray-300">
				<p className="text-sm font-semibold">{`Today's New RX`}</p>
			</div>
			<div
				className="max-h-[400px] overflow-y-auto commonscrollbarhide"
				style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
			>
				{patients.map((patient, index) => (
					<div 
						key={patient.patient_id} 
						className={`flex items-start py-1 px-2 ${getTextColor(index)} border-b border-gray-200 last:border-b-0`}
					>
						<div className="w-[40%] min-w-0">
							<p className="text-xs font-semibold text-left uppercase break-all">
								{patient.patient_name}
							</p>
						</div>
						<div className="w-[60%] text-xs text-left break-words flex flex-wrap ">
							{patient.rxnumber?.map((rx, rxIndex) => (
								<React.Fragment key={rxIndex}>
									<RxNumber rx_number={rx} className_1="text-xs" />
									{rxIndex < patient.rxnumber.length - 1 && <span className="mr-1">,</span>}
								</React.Fragment>
							))}
						</div>
					</div>
				))}
			</div>
		</div>
	)
})

NewRxCard.displayName = 'NewRxCard'

export default NewRxCard

